<mat-toolbar class="menu">
    <span class="spacer"></span>
    <div class="actions">
      <button matTooltip="Dashboard" mat-icon-button routerLink="/files"><mat-icon aria-label="Dashboard">download</mat-icon></button>
      <button matTooltip="My account" mat-icon-button routerLink="/account"><mat-icon aria-label="My account">person_outline</mat-icon></button>
      <button matTooltip="Logout" mat-icon-button (click)="logout()"><mat-icon aria-label="Logout">power_settings_new</mat-icon></button>
    </div>
</mat-toolbar>

<br />
<h1 class="center compressed" style="width: 100%;">{{ws.title()}}</h1>
<hr />

<!-- Add Content Here -->
<router-outlet></router-outlet>
